module.exports = __webpack_public_path__ + "static/chijoke-2f789b9860c5e27947a677a9b9f87c54.png";